var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "both-pd-box1" }, [
      _c(
        "div",
        {
          staticStyle: {
            background: "#fff",
            padding: "10px 30px",
            "border-radius": "20px",
          },
        },
        [
          _c("h3", [_vm._v("排行榜页面管理")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "200px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排行榜顶部背景图", prop: "imgUrl" } },
                    [
                      _c("upload", {
                        attrs: { name: "imgUrl", "img-url": _vm.form.imgUrl },
                        on: {
                          pictureAddress: function ($event) {
                            return _vm.onPictureAddress($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { color: "#aaaaaa" } }, [
                        _vm._v("建议尺寸750px*340px PNG图片"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v(" 保存 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }